import React, { Component } from "react"
import OurTeam from "../Team/index"

class OurTeamSection extends Component {
  render() {
    return (
      <section id="our-team-section">
        <div className="container">
          <div className="row">
            <div className="col-12 about-pb">
              <div className="section-header">
                <h2 className="section-head-title m-0">Our Team</h2>
              </div>
              <p className="lead text-center">
                At Morosoft, the Pakistan’s most talented developers, designers,
                and leaders
                <br />
                are shaping the future of programming and development.
              </p>
            </div>
          </div>

          <div className="row text-center">
            <div className="col-12">
              <OurTeam />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default OurTeamSection
